import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import DashboardTopBar from "./DashboardTopBar";
import DashboardTabs from "./DashboardTabs";
import Loader from "../common/Loader";

export default function ContinuousImprovementDashboard() {
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [filters, setFilters] = useState({
    department: "All",
    status: "All",
    ideaType: "All",
    impact: "All",
  });

  useEffect(() => {
    // Simulate data loading
    const loadData = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(loadData);
  }, []);

  const handleFilterChange = (field) => (event) => {
    setFilters({ ...filters, [field]: event.target.value });
  };

  if (loading) {
    return <Loader message="Loading dashboard..." />;
  }

  return (
    <Box sx={{ p: 3 }}>
      <DashboardTopBar filters={filters} onFilterChange={handleFilterChange} />
      <DashboardTabs tabIndex={tabIndex} setTabIndex={setTabIndex} />
    </Box>
  );
}
